var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m4.141 1.674.39-.486A.5.5 0 0 1 4.92 1h2.158a.5.5 0 0 1 .39.188l.39.486a2.2 2.2 0 0 0 1.718.826H10a1 1 0 0 1 1 1V10a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h.423a2.2 2.2 0 0 0 1.718-.826M3.75.563l-.39.487a1.2 1.2 0 0 1-.937.45H2a2 2 0 0 0-2 2V10a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-.423a1.2 1.2 0 0 1-.937-.45L8.25.563A1.5 1.5 0 0 0 7.08 0H4.92a1.5 1.5 0 0 0-1.17.563M8.5 6a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m1 0a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0",
    clipRule: "evenodd"
  })));
});
const SvgCamerasmall = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCamerasmall);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00LjE0MTE2IDEuNjc0MzNMNC41MzA1IDEuMTg3NjVDNC42MjUzOSAxLjA2OTA0IDQuNzY5MDUgMSA0LjkyMDk0IDFINy4wNzkwNkM3LjIzMDk1IDEgNy4zNzQ2MSAxLjA2OTA1IDcuNDY5NSAxLjE4NzY1TDcuODU4ODQgMS42NzQzM0M4LjI3NjM0IDIuMTk2MiA4LjkwODQzIDIuNSA5LjU3Njc1IDIuNUgxMEMxMC41NTIzIDIuNSAxMSAyLjk0NzcyIDExIDMuNVYxMEMxMSAxMC41NTIzIDEwLjU1MjMgMTEgMTAgMTFIMkMxLjQ0NzcyIDExIDEgMTAuNTUyMyAxIDEwVjMuNUMxIDIuOTQ3NzIgMS40NDc3MiAyLjUgMiAyLjVIMi40MjMyNUMzLjA5MTU3IDIuNSAzLjcyMzY2IDIuMTk2MiA0LjE0MTE2IDEuNjc0MzNaTTMuNzQ5NjMgMC41NjI5NThMMy4zNjAyOSAxLjA0OTYzQzMuMTMyNTcgMS4zMzQyOSAyLjc4Nzc5IDEuNSAyLjQyMzI1IDEuNUgyQzAuODk1NDMxIDEuNSAwIDIuMzk1NDMgMCAzLjVWMTBDMCAxMS4xMDQ2IDAuODk1NDMxIDEyIDIgMTJIMTBDMTEuMTA0NiAxMiAxMiAxMS4xMDQ2IDEyIDEwVjMuNUMxMiAyLjM5NTQzIDExLjEwNDYgMS41IDEwIDEuNUg5LjU3Njc1QzkuMjEyMjEgMS41IDguODY3NDMgMS4zMzQyOSA4LjYzOTcxIDEuMDQ5NjNMOC4yNTAzNyAwLjU2Mjk1OEM3Ljk2NTcxIDAuMjA3MTM1IDcuNTM0NzQgMCA3LjA3OTA2IDBINC45MjA5NEM0LjQ2NTI2IDAgNC4wMzQyOSAwLjIwNzEzNSAzLjc0OTYzIDAuNTYyOTU4Wk04LjUgNkM4LjUgNy4zODA3MSA3LjM4MDcxIDguNSA2IDguNUM0LjYxOTI5IDguNSAzLjUgNy4zODA3MSAzLjUgNkMzLjUgNC42MTkyOSA0LjYxOTI5IDMuNSA2IDMuNUM3LjM4MDcxIDMuNSA4LjUgNC42MTkyOSA4LjUgNlpNOS41IDZDOS41IDcuOTMzIDcuOTMzIDkuNSA2IDkuNUM0LjA2NyA5LjUgMi41IDcuOTMzIDIuNSA2QzIuNSA0LjA2NyA0LjA2NyAyLjUgNiAyLjVDNy45MzMgMi41IDkuNSA0LjA2NyA5LjUgNloiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";